const constants = {

    AUTH: {
      
    },
    ANALYZE: {
        AGENDA_MIN_WIDTH: 60,
        LIVE_MOD_REAL_TIME: 1000,
        LIVE_MOD_OVERALL_TIME: 5000,
        LIVE_MOD_LIMIT_GRAPH_COUNTS: 3,
    },
    DASHBOARD: {

    },
    OTHER: {
        MOBILE_MIN_WIDTH: 600
    },
    PARTICIPANTS_PER_PAGE: 50
  };
  
  export default constants;